export default __webpack_public_path__ + "static/media/img-hero-mobile-03-beatz.257f1319.jpg";